<p *ngIf="accessDenied">
    Zugang verweigert <a class="btn btn-secondary btn-sm" routerLink="/research">Zurück</a>
</p>

<p *ngIf="missing">
    Nicht gefunden <a class="btn btn-secondary btn-sm" routerLink="/research">Zurück</a>
</p>

<ng-container *ngIf="!accessDenied && !missing">
    <div class="card my-3">
        <div class="card-header">
            <div style="display: grid; grid-template-columns: auto auto">
                <h3>
                    <span *ngIf="project"><span *ngIf="project?.number">#{{ project?.number}}</span> {{ project?.status | projectNaming }} "{{ project?.title_project ?? project?.title }}"</span>
                    <span *ngIf="!project">Neue Idee</span>
                </h3>

                <!--<div class="text-center">
                    <span class="text-white bg-info py-1 px-2 fs-5 border-info" *ngIf="project">
                        {{ project?.status | projectStatus }}
                    </span>
                </div>-->

                <div class="text-end">
                    <ng-template #toggleOnHoldTemplate><div [innerHtml]="accessService.authReason(project, 'PROJECT_TOGGLE_ON_HOLD')"></div></ng-template>
                    <ng-container *ngIf="PID !== '0' && project?.status !== ProjectStatus.ON_HOLD">
                        <button type="button" class="btn btn-warning me-2" placement="bottom" containerClass="auth-tooltip"
                                *ngIf="accessService.authorized(project, 'PROJECT_TOGGLE_ON_HOLD')"
                                [tooltip]="toggleOnHoldTemplate"
                                [delay]="500"
                                [disabled]="navigationDisabled"
                                (click)="setStatusWithInput(ProjectStatus.ON_HOLD, 'Sicher, dass Sie den Status auf On Hold setzen wollen?')">
                            Auf "On Hold" setzen
                        </button>
                    </ng-container>
                    <ng-container *ngIf="project?.status === ProjectStatus.ON_HOLD">
                        <button type="button" class="btn btn-warning me-2" placement="bottom" containerClass="auth-tooltip"
                                *ngIf="accessService.authorized(project, 'PROJECT_TOGGLE_ON_HOLD')"
                                [tooltip]="toggleOnHoldTemplate"
                                [delay]="500"
                                [disabled]="navigationDisabled"
                                (click)="resetStatus()">
                            "On Hold" aufheben
                        </button>
                    </ng-container>

                    <ng-template #reloadTemplate><div [innerHtml]="accessService.authReason(project, 'RELOAD')"></div></ng-template>
                    <button type="button" class="btn btn-info me-2" placement="bottom" containerClass="auth-tooltip"
                            [disabled]="navigationDisabled || exporting"
                            (click)="refresh()"
                            *ngIf="PID !== '0' && accessService.authorized(project, 'RELOAD')"
                            [tooltip]="reloadTemplate"
                            [delay]="500">Neu laden
                    </button>

                    @if (PID !== '0') {
                        <button type="button" class="btn btn-secondary me-2" [disabled]="navigationDisabled || exporting" (click)="onePager()">Projektübersicht drucken</button>
                        <button type="button" class="btn btn-secondary" [disabled]="navigationDisabled" (click)="gotoList()">Zurück</button>
                    }

                    <ng-template #deleteTemplate><div [innerHtml]="accessService.authReason(project, 'PROJECT_DELETE')"></div></ng-template>
                    <button type="button" class="btn btn-danger ms-2" placement="bottom" containerClass="auth-tooltip"
                            (click)="delete()"
                            *ngIf="PID !== '0' && accessService.authorized(project, 'PROJECT_DELETE')"
                            [tooltip]="deleteTemplate"
                            [delay]="500">Löschen
                    </button>
                </div>
            </div>

            <div class="mb-2">
                <ng-template #setDeclinedTemplate><div [innerHtml]="accessService.authReason(project, 'PROJECT_SET_DECLINED')"></div></ng-template>
                <button type="button" class="btn btn-warning" placement="bottom" containerClass="auth-tooltip"
                        *ngIf="accessService.authorized(project, 'PROJECT_SET_DECLINED')"
                        [tooltip]="setDeclinedTemplate"
                        [delay]="500"
                        [disabled]="navigationDisabled"
                        (click)="setStatusWithInput(ProjectStatus.DECLINED, 'Sicher, dass sie die Idee verwerfen wollen?')">
                    Idee verwerfen
                </button>

                <ng-template #setInElaborationTemplate><div [innerHtml]="accessService.authReason(project, 'PROJECT_SET_IN_ELABORATION')"></div></ng-template>
                <button type="button" class="btn btn-warning ms-2" placement="bottom" containerClass="auth-tooltip"
                        *ngIf="accessService.authorized(project, 'PROJECT_SET_IN_ELABORATION')"
                        [tooltip]="setInElaborationTemplate"
                        [delay]="500"
                        [disabled]="navigationDisabled"
                        (click)="setStatus(ProjectStatus.IN_ELABORATION, 'Sicher, dass Sie die Idee als Projekt fortführen wollen?')">
                    Als Projekt fortführen
                </button>

                <ng-template #setLineTemplate><div [innerHtml]="accessService.authReason(project, 'PROJECT_SET_LINE')"></div></ng-template>
                <button type="button" class="btn btn-warning ms-2" placement="bottom" containerClass="auth-tooltip"
                        *ngIf="accessService.authorized(project, 'PROJECT_SET_LINE')"
                        [tooltip]="setLineTemplate"
                        [delay]="500"
                        [disabled]="navigationDisabled"
                        (click)="setStatusWithDoubleInput(ProjectStatus.LINE, 'Sicher, dass Sie die Idee an die Linie übergeben wollen?')">
                    An Linie übergeben
                </button>

                <ng-template #setEvaluationTemplate><div [innerHtml]="accessService.authReason(project, 'PROJECT_SET_EVALUATION')"></div></ng-template>
                <button type="button" class="btn btn-warning" placement="bottom" containerClass="auth-tooltip"
                        *ngIf="accessService.authorized(project, 'PROJECT_SET_EVALUATION')"
                        [tooltip]="setEvaluationTemplate"
                        [delay]="500"
                        [disabled]="navigationDisabled"
                        (click)="setStatus(ProjectStatus.EVALUATION, 'Sicher, dass Sie den Projektauftrag einreichen wollen?')">
                    Projektauftrag zur Prüfung einreichen
                </button>

                <ng-template #setCancelledTemplate><div [innerHtml]="accessService.authReason(project, 'PROJECT_SET_CANCELLED')"></div></ng-template>
                <button type="button" class="btn btn-warning" placement="bottom" containerClass="auth-tooltip"
                        *ngIf="accessService.authorized(project, 'PROJECT_SET_CANCELLED')"
                        [tooltip]="setCancelledTemplate"
                        [delay]="500"
                        [disabled]="navigationDisabled"
                        (click)="setStatusWithInput(ProjectStatus.CANCELLED, 'Sicher, dass Sie den Projektauftrag stornieren wollen?')">
                    Projektauftrag stornieren
                </button>

                <ng-template #setReviseTemplate><div [innerHtml]="accessService.authReason(project, 'PROJECT_SET_REVISE')"></div></ng-template>
                <button type="button" class="btn btn-warning ms-2" placement="bottom" containerClass="auth-tooltip"
                        *ngIf="accessService.authorized(project, 'PROJECT_SET_REVISE')"
                        [tooltip]="setReviseTemplate"
                        [delay]="500"
                        [disabled]="navigationDisabled"
                        (click)="setStatusWithInput(ProjectStatus.REVISE, 'Sicher, dass Sie den Projektauftrag zur Überarbeitung anfordern wollen?')">
                    Projektauftrag zur Überarbeitung anfordern
                </button>

                <!--<button type="button" class="btn btn-warning ms-2"
                        *ngIf="accessService.authorized(project, 'PROJECT_SET_RELEASED')"
                        [title]="accessService.authReason(project, 'PROJECT_SET_RELEASED')"
                        [disabled]="navigationDisabled"
                        (click)="setStatus(ProjectStatus.RELEASED, 'Sicher, dass Sie den Projektauftrag freigeben wollen?')">
                    Projektauftrag freigeben
                </button>-->

                <ng-template #completionFiledTemplate><div [innerHtml]="accessService.authReason(project, 'PROJECT_SET_COMPLETION_FILED')"></div></ng-template>
                <button type="button" class="btn btn-warning" placement="bottom" containerClass="auth-tooltip"
                        *ngIf="!filedCompletion && accessService.authorized(project, 'PROJECT_SET_COMPLETION_FILED')"
                        [tooltip]="completionFiledTemplate"
                        [delay]="500"
                        [disabled]="navigationDisabled"
                        (click)="fileCompletion()">
                    Projektabschlussbericht
                </button>
                <button type="button" class="btn btn-warning" placement="bottom" containerClass="auth-tooltip"
                        *ngIf="filedCompletion && accessService.authorized(project, 'PROJECT_SET_COMPLETION_FILED')"
                        [tooltip]="completionFiledTemplate"
                        [delay]="500"
                        [disabled]="navigationDisabled"
                        (click)="setStatus(ProjectStatus.COMPLETION_FILED, 'Sicher, dass Sie den Projektabschluss einreichen wollen?')">
                    Projektabschluss einreichen
                </button>

                <!--<button type="button" class="btn btn-warning"
                        *ngIf="accessService.authorized(project, 'PROJECT_SET_COMPLETED')"
                        [title]="accessService.authReason(project, 'PROJECT_SET_COMPLETED')"
                        [disabled]="navigationDisabled"
                        (click)="setStatus(ProjectStatus.COMPLETED, 'Sicher, dass Sie das Projekt abnehmen wollen?')">
                    Projekt abnehmen
                </button>-->

                <ng-template #setCompletedTemplate><div [innerHtml]="accessService.authReason(project, 'PROJECT_SET_COMPLETED')"></div></ng-template>
                <button type="button" class="btn btn-warning" placement="bottom" containerClass="auth-tooltip"
                        *ngIf="accessService.authorized(project, 'PROJECT_SET_COMPLETED')"
                        [tooltip]="setCompletedTemplate"
                        [delay]="500"
                        [disabled]="navigationDisabled"
                        (click)="setStatusWithInput(ProjectStatus.IN_PROGRESS, 'Sicher, dass sie das Projekt nicht abnehmen wollen?')">
                    Projekt nicht abnehmen
                </button>
            </div>

            <div class="container-fluid">
                <div class="row row-status mb-2">
                    <ng-container *ngIf="projectService.hasStatus(project, ProjectStatus.CREATED)">
                        <div class="col current"><i class="fa-solid fa-check"></i> Idee eingelastet</div>
                        <div class="col">In Ausarbeitung</div>
                        <div class="col">In Prüfung</div>
                        <div class="col">Freigegeben</div>
                        <div class="col">In Arbeit</div>
                        <div class="col">Abschluss eingereicht</div>
                        <div class="col">Abgenommen</div>
                    </ng-container>
                    <ng-container *ngIf="projectService.hasStatus(project, ProjectStatus.DECLINED)">
                        <div class="col-2 done"><i class="fa-solid fa-check"></i> Idee eingelastet</div>
                        <div class="col-2 current"><i class="fa-solid fa-check"></i> Idee verworfen</div>
                    </ng-container>
                    <ng-container *ngIf="projectService.hasStatus(project, ProjectStatus.LINE)">
                        <div class="col-2 done"><i class="fa-solid fa-check"></i> Idee eingelastet</div>
                        <div class="col-2 current"><i class="fa-solid fa-check"></i> An Linie übergeben</div>
                    </ng-container>
                    <ng-container *ngIf="projectService.hasStatus(project, ProjectStatus.IN_ELABORATION)">
                        <div class="col done"><i class="fa-solid fa-check"></i> Idee eingelastet</div>
                        <div class="col current"><i class="fa-solid fa-check"></i> In Ausarbeitung</div>
                        <div class="col">In Prüfung</div>
                        <div class="col">Freigegeben</div>
                        <div class="col">In Arbeit</div>
                        <div class="col">Abschluss eingereicht</div>
                        <div class="col">Abgenommen</div>
                    </ng-container>
                    <ng-container *ngIf="projectService.hasStatus(project, ProjectStatus.EVALUATION)">
                        <div class="col done"><i class="fa-solid fa-check"></i> Idee eingelastet</div>
                        <div class="col done"><i class="fa-solid fa-check"></i> In Ausarbeitung</div>
                        <div class="col current"><i class="fa-solid fa-check"></i> In Prüfung</div>
                        <div class="col">Freigegeben</div>
                        <div class="col">In Arbeit</div>
                        <div class="col">Abschluss eingereicht</div>
                        <div class="col">Abgenommen</div>
                    </ng-container>
                    <ng-container *ngIf="projectService.hasStatus(project, ProjectStatus.CANCELLED)">
                        <div class="col-2 done"><i class="fa-solid fa-check"></i> Idee eingelastet</div>
                        <div class="col-2 done"><i class="fa-solid fa-check"></i> In Ausarbeitung</div>
                        <div class="col-2 done"><i class="fa-solid fa-check"></i> In Prüfung</div>
                        <div class="col-2 current"><i class="fa-solid fa-check"></i> Storniert</div>
                    </ng-container>
                    <ng-container *ngIf="projectService.hasStatus(project, ProjectStatus.REVISE)">
                        <div class="col done"><i class="fa-solid fa-check"></i> Idee eingelastet</div>
                        <div class="col current"><i class="fa-solid fa-check"></i> Überarbeitung</div>
                        <div class="col">In Ausarbeitung</div>
                        <div class="col">In Prüfung</div>
                        <div class="col">Freigegeben</div>
                        <div class="col">In Arbeit</div>
                        <div class="col">Abschluss eingereicht</div>
                        <div class="col">Abgenommen</div>
                    </ng-container>
                    <ng-container *ngIf="projectService.hasStatus(project, ProjectStatus.RELEASED)">
                        <div class="col done"><i class="fa-solid fa-check"></i> Idee eingelastet</div>
                        <div class="col done"><i class="fa-solid fa-check"></i> In Ausarbeitung</div>
                        <div class="col done"><i class="fa-solid fa-check"></i> In Prüfung</div>
                        <div class="col current"><i class="fa-solid fa-check"></i> Freigegeben</div>
                        <div class="col">In Arbeit</div>
                        <div class="col">Abschluss eingereicht</div>
                        <div class="col">Abgenommen</div>
                    </ng-container>
                    <ng-container *ngIf="projectService.hasStatus(project, ProjectStatus.IN_PROGRESS)">
                        <div class="col done"><i class="fa-solid fa-check"></i> Idee eingelastet</div>
                        <div class="col done"><i class="fa-solid fa-check"></i> In Ausarbeitung</div>
                        <div class="col done"><i class="fa-solid fa-check"></i> In Prüfung</div>
                        <div class="col done"><i class="fa-solid fa-check"></i> Freigegeben</div>
                        <div class="col current"><i class="fa-solid fa-check"></i> In Arbeit</div>
                        <div class="col">Abschluss eingereicht</div>
                        <div class="col">Abgenommen</div>
                    </ng-container>
                    <ng-container *ngIf="projectService.hasStatus(project, ProjectStatus.COMPLETION_FILED)">
                        <div class="col done"><i class="fa-solid fa-check"></i> Idee eingelastet</div>
                        <div class="col done"><i class="fa-solid fa-check"></i> In Ausarbeitung</div>
                        <div class="col done"><i class="fa-solid fa-check"></i> In Prüfung</div>
                        <div class="col done"><i class="fa-solid fa-check"></i> Freigegeben</div>
                        <div class="col done"><i class="fa-solid fa-check"></i> In Arbeit</div>
                        <div class="col current"><i class="fa-solid fa-check"></i> Abschluss eingereicht</div>
                        <div class="col">Abgenommen</div>
                    </ng-container>
                    <ng-container *ngIf="projectService.hasStatus(project, ProjectStatus.COMPLETED)">
                        <div class="col done"><i class="fa-solid fa-check"></i> Idee eingelastet</div>
                        <div class="col done"><i class="fa-solid fa-check"></i> In Ausarbeitung</div>
                        <div class="col done"><i class="fa-solid fa-check"></i> In Prüfung</div>
                        <div class="col done"><i class="fa-solid fa-check"></i> Freigegeben</div>
                        <div class="col done"><i class="fa-solid fa-check"></i> In Arbeit</div>
                        <div class="col done"><i class="fa-solid fa-check"></i> Abschluss eingereicht</div>
                        <div class="col current"><i class="fa-solid fa-check"></i> Abgenommen</div>
                    </ng-container>
                    <ng-container *ngIf="projectService.hasStatus(project, ProjectStatus.ON_HOLD)">
                        <div class="col">{{ project.status_prev | projectStatus }}</div>
                        <div class="col hold">On Hold</div>
                    </ng-container>
                </div>
            </div>

            <p *ngIf="projectService.hasStatus(project, ProjectStatus.DECLINED)" class="p-2 bg-warning">
                Verworfen am {{ project?.date_declined | date: 'dd.MM.yyyy' }} von {{ project?.decliner }}: {{ project?.reason_declined }}
            </p>

            <p *ngIf="projectService.hasStatus(project, ProjectStatus.CANCELLED)" class="p-2 bg-warning">
                Storniert am {{ project?.date_cancelled | date: 'dd.MM.yyyy' }} von {{ project?.canceller }}: {{ project?.reason_cancelled }}
            </p>

            <p *ngIf="projectService.hasStatus(project, ProjectStatus.REVISE)" class="p-2 bg-warning">
                Begründung: {{ project?.reason_revised }}
            </p>

            <p *ngIf="projectService.hasStatus(project, ProjectStatus.ON_HOLD)" class="p-2 bg-warning">
                Begründung: {{ project?.reason_onhold }}
            </p>

            <p *ngIf="projectService.hasStatus(project, ProjectStatus.IN_PROGRESS) && project?.reason_decompleted" class="p-2 bg-warning">
                Projekt nicht abgenommen, Begründung: {{ project?.reason_decompleted }}
            </p>

            <ul class="nav nav-tabs card-header-tabs">
                <li class="nav-item">
                    <a class="nav-link" data-toggle="tab"
                       [class.active]="tab === ProjectTab.IDEA"
                       (click)="setTab(ProjectTab.IDEA)"
                       [class.disabled]="navigationDisabled">
                        Idee
                    </a>
                </li>
                <ng-container *ngIf="PID !== '0' && accessService.authorized(project, 'NAVIGATION_SHOW_OTHERS')">
                    <li class="nav-item">
                        <a class="nav-link" data-toggle="tab"
                           [class.active]="tab === ProjectTab.GOALS"
                           (click)="setTab(ProjectTab.GOALS)"
                           [class.disabled]="navigationDisabled">
                            Ziele <span class="badge bg-danger" *ngIf="badges.goals.length > 0" [tooltip]="badges.goals.join(', ')">{{ badges.goals.length }}</span>
                        </a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" data-toggle="tab"
                           [class.active]="tab === ProjectTab.ORGANISATION"
                           (click)="setTab(ProjectTab.ORGANISATION)"
                           [class.disabled]="navigationDisabled">
                            Organisation <span class="badge bg-danger" *ngIf="badges.organisation.length > 0" [tooltip]="badges.organisation.join(', ')">{{ badges.organisation.length }}</span>
                        </a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" data-toggle="tab"
                           [class.active]="tab === ProjectTab.COSTS"
                           (click)="setTab(ProjectTab.COSTS)"
                           [class.disabled]="navigationDisabled">
                            Kosten <span class="badge bg-danger" *ngIf="badges.costs.length > 0" [tooltip]="badges.costs.join(', ')">{{ badges.costs.length }}</span>
                        </a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" data-toggle="tab"
                           [class.active]="tab === ProjectTab.DATES"
                           (click)="setTab(ProjectTab.DATES)"
                           [class.disabled]="navigationDisabled">
                            Zeitplan <span class="badge bg-danger" *ngIf="badges.dates.length > 0" [tooltip]="badges.dates.join(', ')">{{ badges.dates.length }}</span>
                        </a>
                    </li>
                    <li class="nav-item" *ngIf="accessService.authorized(project, 'NAVIGATION_SHOW_REPORTING')">
                        <a class="nav-link" data-toggle="tab"
                           [class.active]="tab === ProjectTab.REPORTING"
                           (click)="setTab(ProjectTab.REPORTING)"
                           [class.disabled]="navigationDisabled">
                            Statusupdate
                        </a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" data-toggle="tab"
                           [class.active]="tab === ProjectTab.RISKS"
                           (click)="setTab(ProjectTab.RISKS)"
                           [class.disabled]="navigationDisabled">
                            Risiken
                        </a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" data-toggle="tab"
                           [class.active]="tab === ProjectTab.STAKEHOLDER"
                           (click)="setTab(ProjectTab.STAKEHOLDER)"
                           [class.disabled]="navigationDisabled">
                            Stakeholder
                        </a>
                    </li>
                    <li class="nav-item" *ngIf="accessService.authorized(project, 'NAVIGATION_SHOW_EXTERNAL')">
                        <a class="nav-link" data-toggle="tab"
                           [class.active]="tab === ProjectTab.EXTERNAL"
                           (click)="setTab(ProjectTab.EXTERNAL)"
                           [class.disabled]="navigationDisabled">
                            Anlage <span class="badge bg-danger" *ngIf="badges.external.length > 0" [tooltip]="badges.external.join(', ')">{{ badges.external.length }}</span>
                        </a>
                    </li>
                    <li class="nav-item" *ngIf="accessService.authorized(project, 'NAVIGATION_SHOW_APPROVALS')">
                        <a class="nav-link" data-toggle="tab"
                           [class.active]="tab === ProjectTab.APPROVALS"
                           (click)="setTab(ProjectTab.APPROVALS)"
                           [class.disabled]="navigationDisabled">
                            Freigaben
                        </a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" data-toggle="tab"
                           [class.active]="tab === ProjectTab.DOCUMENTS"
                           (click)="setTab(ProjectTab.DOCUMENTS)"
                           [class.disabled]="navigationDisabled">
                            Referenzen
                        </a>
                    </li>
                    <li class="nav-item" *ngIf="filedCompletion || accessService.authorized(project, 'NAVIGATION_SHOW_COMPLETION')">
                        <a class="nav-link" data-toggle="tab"
                           [class.active]="tab === ProjectTab.COMPLETION"
                           (click)="setTab(ProjectTab.COMPLETION)"
                           [class.disabled]="navigationDisabled">
                            Abschluss <span class="badge bg-danger" *ngIf="badges.completion.length > 0" [tooltip]="badges.completion.join(', ')">{{ badges.completion.length }}</span>
                        </a>
                    </li>
                </ng-container>
            </ul>
        </div>

        <app-research-idea
                *ngIf="tab === ProjectTab.IDEA"
                [PID]="PID"
                [reloadTrigger]="reloadCounter()"
                (changeProject)="handleChangeProject()"
                (changeViewMode)="toggleNavigation($event)"
        />

        <ng-container *ngIf="PID !== '0'">
            <app-research-goals
                    *ngIf="tab === ProjectTab.GOALS"
                    [PID]="PID"
                    [reloadTrigger]="reloadCounter()"
                    (changeProject)="handleChangeProject()"
                    (changeViewMode)="toggleNavigation($event)"
            />
            <app-research-organisation
                    *ngIf="tab === ProjectTab.ORGANISATION"
                    [PID]="PID"
                    [reloadTrigger]="reloadCounter()"
                    (changeProject)="handleChangeProject()"
                    (changeViewMode)="toggleNavigation($event)"
            />
            <app-research-costs
                    *ngIf="tab === ProjectTab.COSTS"
                    [PID]="PID"
                    [reloadTrigger]="reloadCounter()"
                    (changeProject)="handleChangeProject()"
                    (changeViewMode)="toggleNavigation($event)"
            />
            <app-research-dates
                    *ngIf="tab === ProjectTab.DATES"
                    [PID]="PID"
                    [reloadTrigger]="reloadCounter()"
                    (changeProject)="handleChangeProject()"
                    (changeViewMode)="toggleNavigation($event)"
            />
            <app-research-reporting
                    *ngIf="tab === ProjectTab.REPORTING"
                    [PID]="PID"
                    [reloadTrigger]="reloadCounter()"
                    (changeProject)="handleChangeProject()"
                    (changeViewMode)="toggleNavigation($event)"
            />
            <app-research-risks
                    *ngIf="tab === ProjectTab.RISKS"
                    [PID]="PID"
                    [reloadTrigger]="reloadCounter()"
                    (changeProject)="handleChangeProject()"
                    (changeViewMode)="toggleNavigation($event)"
            />
            <app-research-stakeholder
                    *ngIf="tab === ProjectTab.STAKEHOLDER"
                    [PID]="PID"
                    [reloadTrigger]="reloadCounter()"
                    (changeProject)="handleChangeProject()"
                    (changeViewMode)="toggleNavigation($event)"
            />
            <app-research-external
                    *ngIf="tab === ProjectTab.EXTERNAL"
                    [PID]="PID"
                    [reloadTrigger]="reloadCounter()"
                    (changeProject)="handleChangeProject()"
                    (changeViewMode)="toggleNavigation($event)"
            />
            <app-research-approvals
                    *ngIf="tab === ProjectTab.APPROVALS"
                    [PID]="PID"
                    [reloadTrigger]="reloadCounter()"
                    (changeProject)="handleChangeProject()"
                    (changeViewMode)="toggleNavigation($event)"
            />
            <app-research-documents
                    *ngIf="tab === ProjectTab.DOCUMENTS"
                    [PID]="PID"
                    [reloadTrigger]="reloadCounter()"
                    (changeProject)="handleChangeProject()"
                    (changeViewMode)="toggleNavigation($event)"
            />
            <app-research-completion
                    *ngIf="tab === ProjectTab.COMPLETION"
                    [PID]="PID"
                    [reloadTrigger]="reloadCounter()"
                    (changeProject)="handleChangeProject()"
                    (changeViewMode)="toggleNavigation($event)"
            />
        </ng-container>
    </div>
</ng-container>
